
/**
 * Process tags for submission to the API, handling different tag formats
 */
export const processTagsForSubmission = (tags: any) => {
  if (!Array.isArray(tags)) return [];
  
  return tags
    .map(tag => {
      // Handle both string IDs and object tags
      if (typeof tag === 'object' && tag !== null) {
        return tag.id;
      }
      return tag;
    })
    .filter(Boolean); // Filter out any null/undefined values
};
